<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-form-create-contact p-2">
      <form class="">
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-row">
              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="code" class="">Reference</label>
                  <input name="reference" id="reference" v-model="contact.code" placeholder="######" type="text" class="form-control" disabled>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="type" class="">Contact type</label>
                  <select name="type" id="type" v-model="contact.type" class="form-control">
                    <option value="">- Choose a type -</option>
                    <option value="individual">Individual</option>
                    <option value="club">Club</option>
                    <option value="school">School</option>
                    <option value="company">Company</option>
                    <option value="organization">Other organization</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="position-relative form-group">
                  <label for="start_date" class="">Start date</label>
                  <date-picker name="start_date" id="start_date" v-model="contact.start_date" lang="fr"></date-picker>
                </div>
              </div>
              <div class="col-md-3">
                <div class="position-relative form-group">
                  <label for="status" class="">Status</label>
                  <select name="status" id="status" v-model="contact.status" class="form-control border-0 text-white" v-bind:class="{ 'bg-success': contact.status == 'active', 'bg-danger': contact.status == 'inactive' }">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-3 offset-md-1">
            <div class="form-row">
            </div>
          </div> -->
        </div>
        <div class="divider"></div>
        <div class="form-row individual">
          <h2 class="col-md-12 my-3 d-none">Contact info</h2>
          <div class="col-md-12">
            <div class="form-row individual" v-if="contact.type == 'individual'">
              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="gender" class="">Title</label>
                  <select name="gender" id="gender" v-model="contact.gender" class="form-control">
                    <option value="m">M</option>
                    <option value="f">Mme</option>
                  </select>
                </div>
              </div>
              <div class="col-md-5">
                <div class="position-relative form-group">
                  <label for="firstname" class="">Firstname</label>
                  <input name="firstname" id="firstname" v-model="contact.firstname" placeholder="" type="text" class="form-control">
                </div>
              </div>
              <div class="col-md-5">
                <div class="position-relative form-group">
                  <label for="lastname" class="">Lastname</label>
                  <input name="lastname" id="lastname" v-model="contact.lastname" placeholder="" type="text" class="form-control">
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="birthdate" class="">Birthdate</label>
                  <date-picker name="birthdate" id="birthdate" v-model="contact.birthdate" lang="en" :not-after="new Date()"></date-picker>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="nationality" class="">Nationality</label>
                  <select name="nationality" id="nationality" v-model="contact.nationality" class="form-control">
                    <option value=""></option>
                    <option value="BE">Belgium</option>
                    <option value="ES">Spain</option>
                    <option value="FR">France</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="language" class="">Language</label>
                  <select name="language" id="language" v-model="contact.language" class="form-control">
                    <option value=""></option>
                    <option value="fr">French</option>
                    <option value="es">Spanish</option>
                    <option value="en">English</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-row organization" v-else>
              <div class="col-md-7">
                <div class="position-relative form-group">
                  <label for="fullname" class="">Full name</label>
                  <input name="fullname" id="fullname" v-model="contact.fullname" placeholder="" type="text" class="form-control">
                </div>
              </div>
              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="organization_type" class="">Juridic form</label>
                  <select name="organization_type" id="organization_type" v-model="contact.organization_type" class="form-control">
                    <option value=""></option>
                    <option value="srl">SPRL</option>
                    <option value="sa">SA</option>
                    <option value="asbl">ASBL</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="position-relative form-group">
                  <label for="vat_number" class="">VAT number</label>
                  <input name="vat_number" id="vat_number" v-model="contact.vat_number" placeholder="" type="text" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-3 offset-md-1">
            <div class="form-row">
            </div>
          </div> -->
        </div>
        <button v-if="!showMoreInfo" type="button" class="btn-shadow d-inline-flex align-items-center btn btn-link px-0" v-on:click="showMoreInfo = true">
          + More info
        </button>
        <button v-if="showMoreInfo" type="button" class="btn-shadow d-inline-flex align-items-center btn btn-link px-0" v-on:click="showMoreInfo = false">
          - Less info
        </button>
        <div v-if="showMoreInfo">
          <div class="divider"></div>
          <div class="form-row">
            <h5 class="col-md-12 mb-3">Contact details</h5>
            <div class="col-md-8">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="street" class="">Contact address</label> -->
                    <input name="street" id="street" v-model="contact.contact_detail.street" placeholder="Street" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="street2" class="">Street (2)</label> -->
                    <input name="street2" id="street2" v-model="contact.contact_detail.street2" placeholder="Street 2" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <!-- <label for="zip" class="">Zip</label> -->
                    <input name="zip" id="zip" v-model="contact.contact_detail.zip" placeholder="Zip" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="position-relative form-group">
                    <!-- <label for="city" class="">City</label> -->
                    <input name="city" id="city" v-model="contact.contact_detail.city" placeholder="City" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <!-- <label for="nationality" class="">Nationality</label> -->
                    <select name="nationality" id="nationality" v-model="contact.contact_detail.country" class="form-control">
                      <option value="">Select country</option>
                      <option value="BE" selected>Belgium</option>
                      <option value="ES">Spain</option>
                      <option value="FR">France</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 offset-md-0">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="email" class="">Emails and phones</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="envelope"/></span></div>
                      <input name="email" id="email" v-model="contact.contact_detail.email" placeholder="Email" type="email" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="email2" class="">Email 2</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="envelope"/></span></div>
                      <input name="email2" id="email2" v-model="contact.contact_detail.email2" placeholder="Email 2" type="email" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="phone" class="">Phone</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="phone"/></span></div>
                      <input name="phone" id="phone" v-model="contact.contact_detail.phone" placeholder="Phone" type="text" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="phone2" class="">Phone 2</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="phone"/></span></div>
                      <input name="phone2" id="phone2" v-model="contact.contact_detail.phone2" placeholder="Phone 2" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="form-row">
            <h5 class="col-md-12 mb-3">Billing details</h5>
            <div class="col-md-12">
              <div class="custom-checkbox custom-control mb-2">
                <input v-model="sameAsContactDetails" type="checkbox" id="same_as_contact_details" class="custom-control-input">
                <label class="custom-control-label" for="same_as_contact_details">Same as contact details</label>
              </div>
            </div>
          </div>
          <fieldset :disabled="sameAsContactDetails">
          <div class="form-row">
            <div class="col-md-8">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="street" class="">Billing address and contacts</label> -->
                    <input v-model="contact.billing_contact_detail.street" name="street" id="street" placeholder="Street" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="street2" class="">Street (2)</label> -->
                    <input v-model="contact.billing_contact_detail.street" name="street2" id="street2" placeholder="Street 2" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <!-- <label for="zip" class="">Zip</label> -->
                    <input v-model="contact.billing_contact_detail.zip" name="zip" id="zip" placeholder="Zip" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="position-relative form-group">
                    <!-- <label for="city" class="">City</label> -->
                    <input v-model="contact.billing_contact_detail.city" name="city" id="city" placeholder="City" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="position-relative form-group">
                    <!-- <label for="nationality" class="">Nationality</label> -->
                    <select v-model="contact.billing_contact_detail.country" name="nationality" id="nationality" class="form-control">
                      <option value="">Select country</option>
                      <option value="BE" selected>Belgium</option>
                      <option value="ES">Spain</option>
                      <option value="FR">France</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 offset-md-0">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="email" class="">Emails and phones</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="envelope"/></span></div>
                      <input v-model="contact.billing_contact_detail.email" name="email" id="email" placeholder="Email" type="email" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="email2" class="">Email 2</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="envelope"/></span></div>
                      <input v-model="contact.billing_contact_detail.email2" name="email2" id="email2" placeholder="Email 2" type="email" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="phone" class="">Phone</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="phone"/></span></div>
                      <input v-model="contact.billing_contact_detail.phone" name="phone" id="phone" placeholder="Phone" type="text" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative form-group">
                    <!-- <label for="phone2" class="">Phone 2</label> -->
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text"><font-awesome-icon icon="phone"/></span></div>
                      <input v-model="contact.billing_contact_detail.phone2" name="phone2" id="phone2" placeholder="Phone 2" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            </fieldset>
          <div class="divider"></div>
          <div class="form-row">
            <h5 class="col-md-12">Administrative information</h5>
            <div class="col-md-12">
              <div class="form-row">
                <div class="w-100"></div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="registration_number" class="">Registration number</label>
                    <input name="registration_number" id="registration_number" v-model="contact.registration_number" placeholder="" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="id_card_number" class="">ID card number</label>
                    <input name="id_card_number" id="id_card_number" v-model="contact.id_card_number" placeholder="" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="passport_number" class="">Passport number</label>
                    <input name="passport_number" id="passport_number" v-model="contact.passport_number" placeholder="" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="birthcity" class="">Birth city</label>
                    <input name="birthcity" id="birthcity" v-model="contact.birthcity" placeholder="" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="birthcountry" class="">Birth country</label>
                    <select name="birthcountry" id="birthcountry" v-model="contact.birthcountry" class="form-control">
                      <option value="" class="first-option">Select country</option>
                      <option value="BE">Belgium</option>
                      <option value="ES">Spain</option>
                      <option value="FR">France</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-3 offset-md-1">
              <div class="form-row">
              </div>
            </div> -->
          </div>
          <div class="form-row">
          </div>
        </div>
      </form>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import DatePicker from 'vue2-datepicker';

library.add(
  faEnvelope,
  faPhone,
);

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    DatePicker,
  },
  data: () => ({
    showMoreInfo: false,
    sameAsContactDetails: true,
    contact: {
      code: '',
      type: 'individual',
      start_date: new Date(),
      status: 'active',
      firstname: '',
      lastname: '',
      gender: '',
      birthdate: '',
      birthcity: '',
      birthcountry: '',
      nationality: '',
      registration_number: '',
      id_card_number: '',
      passport_number: '',
      vat_number: '',
      juridic_form: '',
      contact_detail: {
        street: '',
        street2: '',
        zip: '',
        city: '',
        country: '',
        email: '',
        email2: '',
        phone: '',
        phone2: '',
        website: '',
      },
      billing_contact_detail: {
        street: '',
        street2: '',
        zip: '',
        city: '',
        country: '',
        email: '',
        email2: '',
        phone: '',
        phone2: '',
        website: '',
      },
    },
  }),
};
</script>

<style>
.mx-datepicker {
    width: 100% !important
}
.mx-input {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: 1px solid #ced4da;
}
.input-group-text {
  background-color: transparent;
}
fieldset:disabled .input-group-text {
    background-color: #e9ecef;
}
</style>
